import React, { Component } from "react";

class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
  componentWillMount() {
    this.getTimeUntil(this.props.deadline);
  }
  componentDidMount() {
    setInterval(() => this.getTimeUntil(this.props.deadline), 1000);
  }
  leading0(num) {
    return num < 10 ? "0" + num : num;
  }
  getTimeUntil(deadline) {
    const time = Date.parse(deadline) - Date.parse(new Date());
    if (time < 0) {
      this.setState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    } else {
      const seconds = Math.floor((time / 1000) % 60);
      const minutes = Math.floor((time / 1000 / 60) % 60);
      const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
      const days = Math.floor(time / (1000 * 60 * 60 * 24));
      this.setState({ days, hours, minutes, seconds });
    }
  }
  render() {
    return (
      <div>
        <div className="item-between text-center md:text-start font-aref bg-primary text-white py-2 px-2 rounded-full">
          <button className="text-center cursor-default font-normal text-3xl md:text-5xl px-2 md:px-5">
            {this.leading0(this.state.days)}
            <p className="text-sm font-normal">Days</p>
          </button>
          <button className="text-center cursor-default font-normal text-3xl md:text-5xl px-2 md:px-5">
            {this.leading0(this.state.hours)}
            <p className="text-sm font-semibold">Hours</p>
          </button>
          <button className="text-center cursor-default font-normal text-3xl md:text-5xl px-2 md:px-5 ">
            {this.leading0(this.state.minutes)}
            <p className="text-sm font-semibold">minutes</p>
          </button>
          <button className="text-center cursor-default font-normal text-3xl md:text-5xl px-2 md:px-5 ">
            {this.leading0(this.state.seconds)}
            <p className="text-sm font-semibold">seconds</p>
          </button>
        </div>
      </div>
    );
  }
}
export default Clock;
